var _path, _ellipse, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: "64px",
    height: "64px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#008aa9",
    d: "M48.26,48.26c-3.47,3.48-7.77,5.6-12.26,6.38c-2.64,0.48-5.36,0.48-8,0 c-4.49-0.78-8.79-2.9-12.26-6.38c-8.99-8.98-8.99-23.54,0-32.52c8.98-8.99,23.54-8.99,32.52,0C57.25,24.72,57.25,39.28,48.26,48.26z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 32,
    cy: 61,
    opacity: 0.3,
    rx: 19,
    ry: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M36,28v4h4.847c0.609,0,1.076,0.539,0.99,1.141l-0.592,4.141C41.105,38.268,40.261,39,39.265,39H36 v15.64c-2.64,0.48-5.36,0.48-8,0V39h-4c-1.105,0-2-0.895-2-2v-3c0-1.105,0.895-2,2-2h4v-4c0-6.603,3.559-11.426,12.354-9.854 C41.305,18.316,42,19.154,42,20.12v1.979c0,1.014-0.762,1.879-1.77,1.983C37.41,24.372,36,25.481,36,28z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M32,14c2.577,0,4.674-1.957,4.946-4.461C35.352,9.19,33.699,9,32,9 C19.297,9,9,19.297,9,32c0,1.699,0.19,3.352,0.539,4.946C12.044,36.674,14,34.577,14,32C14,22.075,22.075,14,32,14z",
    opacity: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.461,27.054C51.956,27.326,50,29.423,50,32c0,9.925-8.075,18-18,18 c-2.577,0-4.674,1.957-4.946,4.461C28.648,54.81,30.301,55,32,55c12.703,0,23-10.297,23-23C55,30.301,54.81,28.648,54.461,27.054z",
    opacity: 0.15
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.045,24.927c-0.229,0-0.46-0.053-0.678-0.163c-0.739-0.375-1.033-1.278-0.658-2.017 c2.019-3.977,5.339-7.241,9.347-9.192c0.743-0.364,1.642-0.053,2.005,0.692c0.363,0.745,0.053,1.643-0.692,2.005 c-3.424,1.667-6.26,4.456-7.985,7.853C16.119,24.627,15.592,24.927,15.045,24.927z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.d8f9cb1dacd7a9ab36ec9e4dd07209b6.svg";
export { ForwardRef as ReactComponent };